var ARIA_HIDDEN = 'aria-hidden';
var ARIA_EXPANDED = 'aria-expanded';
var IS_MENU_REGIONS_OPENED = 'is-menu-regions-opened';
var hamburgerBtn = document.querySelector('[data-button="hamburgerBtn"]');
var mobileMenu = document.querySelector('[data-component="mobileMenu"]');
if (mobileMenu) {
  var closeMenuBtn = mobileMenu.querySelector('[data-element="closeMenuBtn"]');
  var openMenu = function openMenu() {
    mobileMenu.setAttribute(ARIA_HIDDEN, false);
    hamburgerBtn.setAttribute(ARIA_EXPANDED, true);
  };
  var closeMenu = function closeMenu() {
    mobileMenu.setAttribute(ARIA_HIDDEN, true);
    hamburgerBtn.setAttribute(ARIA_EXPANDED, false);
    mobileMenu.classList.remove(IS_MENU_REGIONS_OPENED);
  };
  hamburgerBtn.addEventListener('click', openMenu);
  closeMenuBtn.addEventListener('click', closeMenu);
}